/**
 * @generated SignedSource<<e8900cf24c866a963898934fa0760949>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationSyncStatus_integration$data = {
  readonly active: boolean;
  readonly integration_syncs: ReadonlyArray<{
    readonly finished_at: any | null | undefined;
    readonly id: number;
    readonly info_messages: ReadonlyArray<string>;
    readonly started_at: any;
    readonly state: string;
  }>;
  readonly last_sync_at: any | null | undefined;
  readonly state: string;
  readonly " $fragmentType": "IntegrationSyncStatus_integration";
};
export type IntegrationSyncStatus_integration$key = {
  readonly " $data"?: IntegrationSyncStatus_integration$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationSyncStatus_integration">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationSyncStatus_integration",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last_sync_at",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "order_by",
          "value": {
            "id": "desc"
          }
        }
      ],
      "concreteType": "integration_sync",
      "kind": "LinkedField",
      "name": "integration_syncs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "started_at",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "finished_at",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "info_messages",
          "storageKey": null
        }
      ],
      "storageKey": "integration_syncs(limit:1,order_by:{\"id\":\"desc\"})"
    }
  ],
  "type": "integration",
  "abstractKey": null
};
})();

(node as any).hash = "9183aa8e573bca39bf9874788cb2ad06";

export default node;
